import script from "./transaction-index.vue?vue&type=script&setup=true&lang=js"
export * from "./transaction-index.vue?vue&type=script&setup=true&lang=js"

import "./transaction-index.vue?vue&type=style&index=0&id=268d28be&lang=css"

const __exports__ = script;

export default __exports__